import { Select, TextInput } from '@kcftech/design-system';
import { Persona } from '@kcftech/prometheustypescriptapiclient';
import {
    personaIsOther,
    PersonaModalPageProps,
} from 'components/modal/persona/PersonaModal';
import { useMemo } from 'react';

export type PersonaModalPage1Props = Readonly<
    Omit<PersonaModalPageProps, 'selections'> & { selection: Persona | undefined }
>;

export const maxLength = 200;

export function PersonaModalPage1({
    form: {
        register,
        formState: { errors },
    },
    options,
    selection,
}: PersonaModalPage1Props) {
    const personaOptions = useMemo(
        () => options?.Personas.map((p) => ({ value: p.Value, title: p.Text })),
        [options?.Personas]
    );
    return (
        <>
            <Select
                ariaLabel="select primary role"
                label="Your Primary Role"
                error={errors.persona?.message}
                options={personaOptions}
                value={selection}
                placeholder="Select your primary role"
                {...register('persona', {
                    required: 'Primary role is required',
                })}
                style={{
                    marginBottom: personaIsOther(selection) ? '.5rem' : undefined,
                }}
            />
            {personaIsOther(selection) && (
                <TextInput
                    label="Specify Your Primary Role"
                    required
                    error={errors.customPersona?.message}
                    maxLength={maxLength}
                    {...register('customPersona', {
                        required: 'Custom role is required',
                        maxLength: {
                            value: maxLength,
                            message: `Maximum ${maxLength} characters`,
                        },
                    })}
                />
            )}
        </>
    );
}
